// OperatorCriteriaTable.js

const OperatorCriteriaTable = ({ assessments, criteria, fieldOptions }) => {
  const operatorsMap = {};

  if (fieldOptions?.operators && Array.isArray(fieldOptions.operators)) {
    fieldOptions.operators.forEach(operator => {
      const operatorFullName = `${operator.surname} ${operator.name}`;
      operatorsMap[operatorFullName] = {};
      criteria.forEach(criterion => {
        if (criterion.name) {
          operatorsMap[operatorFullName][criterion.name] = [];
        }
      });
    });
  }

  assessments.forEach(assessment => {
    const operator = assessment.agent_name;
    if (operator && operatorsMap[operator] && assessment.items) {
      assessment.items.forEach(item => {
        if (item.score === 0) {
          const criterion = criteria.find(c => c.id === item.criteria_id);
          if (criterion && criterion.name) {
            operatorsMap[operator][criterion.name].push(item);
          }
        }
      });
    }
  });

  const data = Object.entries(operatorsMap).map(([operatorValue, criteriaMap]) => {
    const operatorName = operatorValue;
    const totalCount = Object.values(criteriaMap).flat().length;
    return { operator: operatorName, criteria: criteriaMap, totalCount };
  });

  const maxOperatorLength = data.length > 0
    ? Math.max(...data.map(item => item.operator.length))
    : 0;
  const employeeColumnWidth = Math.max(150, maxOperatorLength * 8);

  data.sort((a, b) => b.totalCount - a.totalCount);
  const criteriaNames = criteria.map(c => c.name);
  const totalColumns = criteriaNames.length + 2;

  return (
    <div className="table-wrapper" style={{ height: '80vh', display: 'flex', flexDirection: 'column' }}>
      <h3>Критерии по операторам</h3>

      {/* Основной контейнер с обычной прокруткой */}
      <div
        style={{
          flex: 1,
          overflow: 'auto', // Включаем нативную прокрутку
          position: 'relative'
        }}
      >
        {/* Таблица */}
        <table className="stats-table" style={{ minWidth: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 3 }}>
            <tr>
              <th style={{
                position: 'sticky', left: 0, zIndex: 3,
                minWidth: `${employeeColumnWidth}px`, width: `${employeeColumnWidth}px`, padding: '8px 15px'
              }}>Оператор</th>
              <th style={{
                position: 'sticky', left: `${employeeColumnWidth}px`, zIndex: 3,
                minWidth: '80px', width: '80px',
                padding: '8px 4px'
              }}>Количество ошибок</th>
              {criteriaNames.map(name => (
                <th
                  key={name}
                  style={{
                    minWidth: '150px',
                    maxWidth: '150px',
                    padding: '8px 4px',
                    wordWrap: 'break-word',
                    whiteSpace: 'normal',
                    verticalAlign: 'top',
                  }}
                >
                  {name}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={totalColumns} style={{ textAlign: 'center' }}>Нет данных</td>
              </tr>
            ) : (
              data.map(item => (
                <tr key={item.operator}>
                  <td style={{
                    position: 'sticky', left: 0, zIndex: 2,
                    minWidth: `${employeeColumnWidth}px`,
                    backgroundColor: 'white'
                  }}>{item.operator}</td>
                  <td style={{
                    position: 'sticky', left: `${employeeColumnWidth}px`, zIndex: 2,
                    minWidth: '80px',
                    backgroundColor: 'white'
                  }}>{item.totalCount}</td>
                  {criteriaNames.map(name => (
                    <td key={name} style={{ minWidth: '150px', zIndex: 1 }}>
                      {item.criteria[name]?.length || 0}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>

          <tfoot style={{ position: 'sticky', bottom: 0, backgroundColor: '#f5f5f5', zIndex: 3 }}>
            <tr>
              <td style={{
                position: 'sticky', left: 0, zIndex: 3,
                minWidth: `${employeeColumnWidth}px`,
                backgroundColor: '#f5f5f5'
              }}>Grand Total</td>
              <td style={{
                position: 'sticky', left: `${employeeColumnWidth}px`, zIndex: 3,
                minWidth: '80px',
                backgroundColor: '#f5f5f5'
              }}>
                {data.reduce((sum, item) => sum + item.totalCount, 0)}
              </td>
              {criteriaNames.map(name => (
                <td key={name}>
                  {data.reduce((sum, item) => sum + (item.criteria[name]?.length || 0), 0)}
                </td>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default OperatorCriteriaTable;